import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { trackCustomerActivity } from '../api/customerActivity';

export default function usePackageViewActivity(productId, visible = true) {
  const session = useSelector(state => state.auth?.isLogin);
  const customerId = session?.user?._id;
  const token = session?.token;
  useEffect(() => {
    if (!visible || !productId || !customerId) return;
    trackCustomerActivity('Package Viewed', { productId }, token);
  }, [productId, visible, customerId, token]);
}
